import React, { memo } from 'react';

import { Dialog } from '../../../../../common/components/Dialog/Dialog';
import Button from '../../../../../common/components/Button/Button';

const SearchPresetDeleteDialog = memo(({ cancel, submit, open }) => {
  const actions = [
    <Button key="no-btn" onClick={cancel}>
      No
    </Button>,
    <Button key="yes-btn" onClick={submit}>
      Yes
    </Button>,
  ];

  return (
    <Dialog actions={actions} modal open={open} fullWidth className="z-index-1300">
      <div className="confirmation-dialog-text">Are you sure?</div>
    </Dialog>
  );
});

export default SearchPresetDeleteDialog;
